exports.getCookie = key => {
  if (typeof window !== 'undefined') {
    const cookies = document.cookie
      .split(';')
      .reduce(function(accumulator, cookie) {
        let cookieParts = cookie.split('=')
        // Some browsers add a space between semicolon that separate cookie values e.g. foo=bar; bar=foo
        // So we need to remove any spaces from the key before adding it to the object
        let key = cookieParts[0].trim()
        let value = cookieParts[1]

        accumulator[key] = value
        return accumulator
      }, {})

    return cookies[key]
  }
}

exports.setCookie = (name, value, expiryDays) => {
  if (typeof window !== 'undefined') {
    const date = new Date()
    date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()
    const output = name + '=' + value + '; ' + expires + ';path=/'
    document.cookie = output
  }
}
